import * as React from 'react';
import { Page } from '@ui/components';
import Store from '@ui/scenes/Store';

const StorePage = () => (
  <Page>
    <Store />
  </Page>
);

export default StorePage;



// WEBPACK FOOTER //
// ./src/pages/Store/Store.tsx